<template>
    <div class="entrust">
        <!--tab切换-->
        <div class="tabbtn" v-if="permisShow('委托管理')">
            <el-radio-group v-model="type" style="margin-bottom: 100px;" @change="changeList">
                <el-radio-button label="委托房源"></el-radio-button>
                <el-radio-button label="委托客源"></el-radio-button>
            </el-radio-group>
        </div>
        <!--搜索条件-->
        <div class="chouse_wrap" v-if="permisShow('委托管理')" style="display: flex;justify-content: space-between">
            <ul class="conditions_list">
                <li class="conditions_list_item total_price_input">
                    <span>委托日期：</span>
                    <span class="total_inp input_box">
                        <el-date-picker
                            v-model="searchData.date"
                            unlink-panels
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            :picker-options="pickerOptions"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            @change="getList()"
                        ></el-date-picker>
                    </span>
                </li>
                <li class="conditions_list_item">
                    <span class="list_item_title">联系电话：</span>
                    <div class="Residential1">
                        <el-input
                            placeholder="请输入"
                            v-model="searchData.phone"
                            @input="getList()"
                            clearable
                        ></el-input>
                    </div>
                </li>
                <li class="conditions_list_item total_price_input">
                    <span>状态：</span>
                    <el-select
                        v-model="searchData.status"
                        placeholder="请选择"
                        @change="getList()"
                        clearable
                    >
                        <el-option
                            v-for="(item,index) in statusList"
                            :key="index"
                            :label="item.valueDesc"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item total_price_input">
                    <span>来源：</span>
                    <el-select
                        v-model="searchData.source"
                        placeholder="请选择"
                        @change="getList()"
                        clearable
                    >
                        <el-option
                            v-for="(item,index) in fromList"
                            :key="index"
                            :label="item.valueDesc"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item" v-if="type==='委托房源'">
                    <span>类型：</span>
                    <el-select
                        v-model="searchData.transactionType"
                        placeholder="请选择"
                        @change="getList()"
                        clearable
                    >
                        <el-option
                            v-for="(item,index) in houseType"
                            :key="index"
                            :label="item.valueDesc"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </li>
                <li class="conditions_list_item" v-else>
                    <span>类型：</span>
                    <el-select
                        v-model="searchData.transactionType"
                        placeholder="请选择"
                        @change="getList()"
                        clearable
                    >
                        <el-option
                            v-for="(item,index) in customerType"
                            :key="index"
                            :label="item.valueDesc"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </li>
            </ul>
        </div>
        <!--委托房源-->
        <div class="house" v-show="type==='委托房源'">
            <!--表-->
            <div class="sales_list_wrap">
                <el-table
                    border
                    highlight-current-row
                    :data="houseEnreust"
                    style="width: 100%"
                    :header-cell-style="setHeaderStyle"
                    v-if="permisShow('委托管理')"
                    @row-click="rowColorclick"
                >
                    <el-table-column prop="inputTime" label="委托日期" width="161px"></el-table-column>
                    <el-table-column prop="transactionType" width="70" label="类型"></el-table-column>
                    <el-table-column prop="residentialAreaName" label="小区"></el-table-column>
                    <el-table-column prop="address" label="房源地址"></el-table-column>
                    <el-table-column prop="price" label="期望售价/租金"></el-table-column>
                    <el-table-column prop="description" label="备注" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="name"  label="称呼"></el-table-column>
                    <el-table-column prop="phone" label="联系电话"></el-table-column>
                    <el-table-column prop="source" width="70px" label="来源"></el-table-column>
                    <el-table-column prop="status" width="70px" label="状态"></el-table-column>
                    <el-table-column prop="resolution" label="处理意见" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="dealEmployee" label="处理人"></el-table-column>
                    <el-table-column prop="dealTime" label="处理时间" width="161px"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <span class="look" :class="{rowColor:scope.row.id===isRowColor}" @click="getDetails(scope.row)">查看详情</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--委托客源-->
        <div class="customer" v-show="type==='委托客源'">
            <!--表-->
            <div class="sales_list_wrap">
                <el-table
                    border
                    highlight-current-row
                    :data="customerEnreust"
                    style="width: 100%"
                    :header-cell-style="setHeaderStyle"
                    v-if="permisShow('委托管理')"
                    @row-click="rowColorclick"
                >
                    <el-table-column prop="inputTime" label="委托日期" width="161px"></el-table-column>
                    <el-table-column prop="transactionType" label="类型"></el-table-column>
                    <el-table-column prop="price" label="租金/总价"></el-table-column>
                    <el-table-column prop="measureArea" label="面积"></el-table-column>
                    <el-table-column prop="name" label="称呼"></el-table-column>
                    <el-table-column prop="phone" label="联系电话"></el-table-column>
                    <el-table-column prop="description" label="备注" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="source" label="来源"></el-table-column>
                    <el-table-column prop="status" label="状态"></el-table-column>
                    <el-table-column prop="resolution" label="处理意见" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="dealEmployee" label="处理人"></el-table-column>
                    <el-table-column prop="dealTime" label="处理时间" width="161px"></el-table-column>
                    <el-table-column label="操作" width="100px">
                        <template slot-scope="scope">
                            <span class="look" :class="{rowColor:scope.row.id===isRowColor}" @click="getDetails(scope.row)">查看详情</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!--分页-->
        <div class="footer_page" v-if="permisShow('委托管理')">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total, prev, pager, next, sizes, jumper"
                :total="total"
            ></el-pagination>
        </div>
        <!--查看委托详情-->
        <div class="details">
            <el-dialog
                :title="type==='委托房源'?'委托房源详情':'委托客源详情'"
                :visible.sync="dialogVisible"
                :width="type==='委托房源'?'750px':'600px'"
            >
                <div class="details-house" v-if="type==='委托房源'">
                    <div class="details-item">
                        <div>委托日期：{{detailsMsg.inputTime}}</div>
                        <div>小区名称：{{detailsMsg.residentialAreaName}}</div>
                        <div>
                            类
                            <span style="visibility: hidden">占位</span>
                            型：{{detailsMsg.transactionType}}
                        </div>
                    </div>
                    <div class="details-item">
                        <div>房屋地址：{{detailsMsg.address}}</div>
                        <div>期望售价/租金：{{detailsMsg.price}}</div>
                    </div>
                </div>
                <div class="details-customer" v-else>
                    <div class="details-item">
                        <div>委托日期：{{detailsMsg.inputTime}}</div>
                        <div>
                            类
                            <span style="visibility: hidden">占位</span>
                            型：{{detailsMsg.transactionType}}
                        </div>
                    </div>
                    <div class="details-item">
                        <div>
                            面
                            <span style="visibility: hidden">占位</span>
                            积：{{detailsMsg.measureArea}}
                        </div>
                        <div>总价/租金：{{detailsMsg.price}}</div>
                    </div>
                </div>
                <div class="details-common">
                    <div class="details-item">
                        <div :style="type==='委托房源'?'width:220px':'width:250px'">
                            称
                            <span style="visibility: hidden">占位</span>
                            呼：{{detailsMsg.name}}
                        </div>
                        <div
                            :style="type==='委托房源'?'width:220px':'width:250px'"
                        >联系方式：{{detailsMsg.phone}}</div>
                    </div>
                    <div class="details-item">
                        备
                        <span style="visibility: hidden">占位</span>
                        注：{{detailsMsg.description}}
                    </div>
                    <div class="details-item">
                        <span style="line-height: 30px">
                            状
                            <span style="visibility: hidden">占位</span>态：
                        </span>
                        <el-select v-model="detailsMsg.status" placeholder="请选择" @change clearable>
                            <el-option
                                v-for="(item,index) in detailstatusList"
                                :key="index"
                                :label="item.valueDesc"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="details-item">
                        <span>处理意见：</span>
                        <el-input
                            style="width: 460px;"
                            type="textarea"
                            :rows="6"
                            placeholder="请输入内容"
                            v-model="detailsMsg.resolution"
                        ></el-input>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="editDealEntrust" v-points>确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { queryCustomer, queryHouse, dealEntrust } from "@/api/manageCenter";
import {getPermis} from '../../vue/util/tool'
export default {
    // name: "委托管理",
    name: "/entrustManagement",
    data() {
        let permisList = JSON.parse(sessionStorage.getItem("permisList"));
        return {
            type: "委托房源",
            permisList,
            //搜索条件
            searchData: {
                date: [], //委托日期
                phone: "", //联系电话
                status: "", //状态
                source: "", //来源
                transactionType: "" //类型
            },
            //状态
            statusList: [
                {
                    valueDesc: "不限",
                    value: ""
                },
                {
                    valueDesc: "未处理",
                    value: "NO"
                },
                {
                    valueDesc: "已处理",
                    value: "YES"
                }
            ],
            //来源
            fromList: [
                {
                    valueDesc: "不限",
                    value: ""
                },
                {
                    valueDesc: "官网",
                    value: "WEB"
                },
                {
                    valueDesc: "微站",
                    value: "WEI"
                }
            ],
            //房源类型
            houseType: [
                {
                    valueDesc: "不限",
                    value: ""
                },
                {
                    valueDesc: "出售",
                    value: "SELL"
                },
                {
                    valueDesc: "出租",
                    value: "LEASE"
                }
            ],
            //客源类型
            customerType: [
                {
                    valueDesc: "不限",
                    value: ""
                },
                {
                    valueDesc: "求购",
                    value: "WANT_TO_BUY"
                },
                {
                    valueDesc: "求租",
                    value: "WANT_TO_RENT"
                }
            ],
            //日期选择
            pickerOptions: {
                shortcuts: [
                    {
                        text: "当天",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    },
                    {
                        text: "本季度",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            picker.$emit("pick", [start, end]);
                        }
                    }
                ]
            },
            //委托房源
            houseEnreust: [],
            //委托客源
            customerEnreust: [],
            //委托房源分页
            total: 0,
            currentPage: 1,
            pageNumber: 1,
            pageSize: 20,
            dialogVisible: false, //详情弹框
            //详情状态
            detailstatusList: [
                {
                    valueDesc: "未处理",
                    value: "NO"
                },
                {
                    valueDesc: "已处理",
                    value: "YES"
                }
            ],
            detailsMsg: {}, //详情信息
            isRowColor: '',
        };
    },

    methods: {
        permisShow(data) {
            // 权限配置
            // console.log(getPermis('委托管理'))
            let result = getPermis('委托管理').indexOf(data);
            if (result >= 0) {
                return true;
            } else {
                return false;
            }
        },
        //修改当前行字体颜色
        rowColorclick(row) {
            this.isRowColor = row.id;
        },
        //房客源切换
        changeList() {
            for (let key in this.searchData) {
                this.searchData[key] = "";
            }
            this.getList();
        },
        //委托搜索
        getList() {
            this.currentPage = 1;
            this.pageNumber = 1;
            this.pageSize = 20;
            this.isRowColor = '';
            if (this.type === "委托房源") {
                this.getHouse();
            } else if (this.type === "委托客源") {
                this.getCustomer();
            }
        },
        //房源委托
        getHouse() {
            let params = Object.assign({}, this.searchData, {
                "page.pageNumber":
                    this.pageNumber * this.pageSize - this.pageSize,
                "page.pageSize": this.pageSize
            });
            this.$post(queryHouse, params).then(res => {
                if (res.success) {
                    this.houseEnreust = res.data;
                    this.total = res.total;
                }
            });
        },
        //客源委托
        getCustomer() {
            let params = Object.assign({}, this.searchData, {
                "page.pageNumber":
                    this.pageNumber * this.pageSize - this.pageSize,
                "page.pageSize": this.pageSize
            });
            this.$post(queryCustomer, params).then(res => {
                if (res.success) {
                    this.customerEnreust = res.data;
                    this.total = res.total;
                }
            });
        },
        //委托分页
        handleCurrentChange(val) {
            this.pageNumber = val;
            if (this.type === "委托房源") {
                this.getHouse();
            } else if (this.type === "委托客源") {
                this.getCustomer();
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            if (this.type === "委托房源") {
                this.getHouse();
            } else if (this.type === "委托客源") {
                this.getCustomer();
            }
        },
        //表头颜色
        setHeaderStyle() {
            return "background-color: #F2F4FF";
        },
        //查看委托详情
        getDetails(row) {
            this.dialogVisible = true;
            this.detailsMsg = Object.assign({}, row);
            this.detailstatusList.map((item, index) => {
                if (this.detailsMsg.status === item.valueDesc) {
                    this.detailsMsg.status = item.value;
                }
            });
        },
        //添加修改委托状态，处理意见
        editDealEntrust() {
            let params = {
                resolution: this.detailsMsg.resolution, //处理意见
                status: this.detailsMsg.status, //处理意见
                id: this.detailsMsg.id, //处理房客源编号
                type: this.type === "委托房源" ? "house" : "customer"
            };
            this.$post(dealEntrust, params).then(res => {
                if (res.success) {
                    if (this.type === "委托房源") {
                        this.getHouse();
                    } else if (this.type === "委托客源") {
                        this.getCustomer();
                    }
                    this.dialogVisible = false;
                     this.isRowColor = "";
                }
            });
        }
    },
    mounted() {
        this.type = sessionStorage.getItem('entrustType')||'委托房源';
        if (this.$route.query.type){
            // console.log(this.$route.query.type)
            this.type = this.$route.query.type;
        }
        this.getList();
    },
    activated() {
        // this.getList();
    }
};
</script>
<style lang="less">
.entrust {
    background: #ffffff;
    .tabbtn {
        padding: 20px 0 0 20px;
        height: 50px;
        .el-radio-button .el-radio-button__inner {
            border-radius: 0 !important;
            background: #ffffff !important;
            height: 30px;
            line-height: 30px;
            padding: 0;
            width: 100px;
            text-align: center;
        }
        .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            background: #5e75e6 !important;
            border-color: #5e75e6 !important;
        }
    }
    .conditions_list {
        display: flex;
        > p {
            cursor: pointer;
            display: flex;
            align-items: center;
            margin-left: 10px;
            font-size: 14px;
            color: #bbb;

            .icon-xiajiantou {
                &.active {
                    transform: rotate(180deg);
                }
            }

            > span {
                padding-left: 5px;
            }
        }

        .conditions_list_item {
            /*background: #f5f5f5;*/
            padding-left: 10px;
            display: flex;
            align-items: center;
            margin-left: 20px;
            > span {
                /*border-right: 1px solid #ccc;*/
                font-size: 12px;
                color: #666666;
                /*padding: 4px 10px 4px 0;*/
                /*min-width: 24px;*/
            }
            .Residential {
                .el-input__inner {
                    width: 140px;
                    /*border: none;*/
                    /*background: #f5f5f5;*/
                }
            }
            .Residential1 {
                .el-input__inner {
                    width: 110px;
                    /*border: none;*/
                    /*background: #f5f5f5;*/
                }
            }
            .el-select {
                /*margin-left: 10px;*/

                .el-input {
                    .el-input__inner {
                        width: 100px;
                        height: 30px;
                        /*border: none;*/
                        /*background: #f5f5f5;*/
                        padding-left: 10px;
                    }

                    .el-input__icon {
                        line-height: 30px;
                    }
                }
            }

            .el-input-group {
                .el-input-group__append {
                    padding: 0 19px;
                    background: #5e75e6;

                    .icon-icon_sousuo {
                        color: white;
                    }
                }

                .el-input__inner {
                    height: 30px;
                    /*background: #f5f5f5;*/
                    padding-left: 0;
                    /*border: none;*/
                    width: 120px;
                }
            }

            &.total_price_input {
                display: flex;
                height: 30px;

                .total_inp {
                    display: flex;
                    align-items: center;
                    /*border: none;*/

                    .el-input {
                        width: 40px;
                        height: 30px;

                        .el-input__inner {
                            height: 30px;
                            /*background: #f5f5f5;*/
                            /*border: none;*/
                            padding: 0;
                            text-align: center;
                        }
                    }
                }
            }
            .el-input__inner {
                height: 30px;
                /*background: #f5f5f5;*/
                border: 1px solid #DBDBDB!important;
            }
            &_address {
                .el-input__inner {
                    width: 160px;
                    /*border: none;*/
                }
            }
        }
    }
    .el-dialog {
        .el-dialog__header {
            padding-left: 30px;
            padding-right: 30px;
        }
        .el-dialog__body {
            padding: 20px 30px !important;
            font-size: 14px !important;
        }
        .el-button--primary {
            background: #5e75e6 !important;
        }
        .el-dialog__footer {
            padding: 20px !important;
            .el-button--default {
                background: #999;
                color: #fff;
            }
        }
        .el-input--suffix .el-input__inner {
            height: 30px !important;
        }
        .el-input__icon {
            line-height: 0;
        }
    }
    .input_box {
        .el-range-input{
            background: #ffffff!important;
        }
    }
    .el-range-editor.el-input__inner{
        padding: 0!important;
    }
    .el-date-editor .el-range__icon{
        margin-left: 0!important;
    }
}
</style>
<style scoped lang="less">
.entrust {
    .rowColor {
        color: #fff !important;
    }
    /*搜索条件*/
    .chouse_wrap {
        display: flex;
        height: 60px;
        align-items: center;
    }
    .look {
        color: #5e75e6;
        cursor: pointer;
    }
    .details {
        &-item {
            display: flex;
            justify-content: flex-start;
            padding-bottom: 20px;
            > div {
                width: 220px;
                margin-right: 10px;
            }
        }
        &-customer {
            .details-item {
                > div {
                    width: 250px;
                    margin-right: 10px;
                }
            }
        }
    }
}
</style>